import { render, staticRenderFns } from "./BaseCampaignTargetingRule.vue?vue&type=template&id=f3f8401c&scoped=true&"
import script from "./BaseCampaignTargetingRule.vue?vue&type=script&lang=js&"
export * from "./BaseCampaignTargetingRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f8401c",
  null
  
)

export default component.exports